import { expandOffCanvas, hideOffcanvas } from '@/front/offcanvas';

export const expand = () => {
  expandOffCanvas();
};

export const close = () => {
  hideOffcanvas();
};
